module.exports = __webpack_public_path__ + "static/assets/0896da795cd8d2199e8cfb968229d04a.svg";